import React, {useEffect} from 'react';
import {connect} from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';

import {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setSupplyType,
  setSetupDeliveries,
  setError,
} from '../saleBlockSlice';
import SetUpDeliveries from '../../../Shared/SetUpDeliveries/SetUpDeliveries';

const DeliveryAddressPage = (props) => {
  let saleType = props.saleType;
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: flowType == 'existsCustomer' ? 'visibility_11' : 'visibility_19', eventLabel: eventLabel});
        break;
      case 'cellular':
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: flowType == 'existsCustomer' ? 'visibility_11' : 'visibility_22', eventLabel: flowType == 'existsCustomer' ? 'screen_6' : 'screen_12'});
        break;
      case 'internet':
        //props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_15', eventLabel: eventLabel});
        break;
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'ממשיכים';
  let currentPageFunction = handleDeliveryAddressPageContinue;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> לאיזו כתובת השליח יגיע? </h1>
      {props.configuration.isAllowTechnitian && (
        <h2 className='sale-title-small'>
          <a href='javascript:void(0)' onClick={handleDeliveryAddressPageBack}>
            התחרטתי, רוצה טכנאי
          </a>
        </h2>
      )}
    </div>
  );

  let isDisplayLeaveSimInBox = saleType == 'cellular';

  let currentPageView = (
    <SetUpDeliveries
      onError={handleOnError}
      selectedAddress={props.selectedAddress}
      saleType={saleType}
      isDisplayLeaveSimInBox={isDisplayLeaveSimInBox}
      onValid={handleDeliveryValidate}
      onSubmit={props.isSubmit}
    />
  );

  function handleOnError(errorId) {

    if ((errorId == 51 || errorId == 50) && saleType == 'cellular') props.setError({isDisplay: true, id: errorId, isOpenWorkOrder: true});
    else {
      props.setError({isDisplay: true, id: errorId});
    }
  }

  function handleDeliveryAddressPageContinue() {
    props.setIsSubmit({isSubmit: true});
  }

  function handleDeliveryAddressPageBack() {
    props.goToPage({page: 'technicianPage', percent: props.percent});

    const eventLabel = props.productsInfo.selectedProducts[0]?.name;
    props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: (flowType == 'existsCustomer' ? 'click_15' : 'click_27'), eventLabel: eventLabel});
  }

  function handleDeliveryValidate(valid) {
    props.setIsSubmit({isSubmit: false});
    if (valid) {
      handleDeliveryAddressPageContinueAfterValid();
    }
    props.setIsSubmit({isSubmit: false});
  }

  function handleDeliveryAddressPageContinueAfterValid() {
    props.setSupplyType({supplyType: 'delivery'});

    const setupDeliveries = {
      isNewAddress: props._setupDeliveries.isNewAddress,
      deliveryTime: props._setupDeliveries.deliveryTime,
      round: props._setupDeliveries.round,
      roundName: props._setupDeliveries.roundName,
      waitFrom: props._setupDeliveries.waitFrom,
      waitTo: props._setupDeliveries.waitTo,
      lfdat: props._setupDeliveries.lfdat,
      weekdayL: props._setupDeliveries.weekdayL,
      pickLocation: props._setupDeliveries.pickLocation,
      isLeaveSimInBox: props._setupDeliveries.isLeaveSimInBox,
    };

    if (props._setupDeliveries.isNewAddress) {
      const address = {
        city: props._address.city,
        cityName: props._address.cityName,
        street: props._address.street,
        streetName: props._address.streetName,
        home: props._address.home,
        apartment: props._address.apartment,
        enter: props._address.enter,
        zipCode: props._address.zipCode,
        technicianHours: props._address.technicianHours,
      };
      setupDeliveries.selectedAddress = address;
    }

    props.setSetupDeliveries({setupDeliveries: setupDeliveries});

    switch (saleType) {
      case 'tv':
        if (flowType == 'existsCustomer' || props.isOtherAddress || props.isSkipToNewCustomer) {
          props.goToPage({page: 'emailPage', percent: 55});
        } else {
          props.goToPage({page: 'otpVerifyPhone', percent: 45});
        }
        break;
      case 'cellular':
        if (flowType == 'existsCustomer' || props.isOtherAddress || props.isSkipToNewCustomer) {
          props.goToPage({page: 'emailPage', percent: 70});
        } else {
          props.goToPage({page: 'otpVerifyPhone', percent: 50});
        }
        break;
      case 'internet':
        if (flowType == 'existsCustomer') {
          props.goToPage({page: 'userAddressPage', percent: 48});
        } else {
          props.goToPage({page: 'personalInfoPage', percent: 60}); 
        }
        break;
    }

    let eventLabel = '';

    switch (saleType) {
      case 'tv':
        eventLabel = props.productsInfo.selectedProducts[0]?.name;
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: (flowType == 'existsCustomer' ? 'click_16' : 'click_28'), eventLabel: eventLabel});
        break;
      case 'cellular':
        eventLabel = props._setupDeliveries.isLeaveSimInBox ? 'תשאירו לי את הסים בתיבה' : 'אל תשאירו לי את הסים בתיבה';
        if (props._setupDeliveries.isNewAddress) {
          props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_26', eventLabel: eventLabel});
        }
        else {
          props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: flowType == 'existsCustomer' ? 'click_27' : 'click_44', eventLabel: eventLabel});
        }
        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'click_1', eventLabel: 'DeliveryAddressPage'});
        break;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {' '}
          {currentPageView}{' '}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    totalPrice: state.saleBlock.totalPrice,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    configuration: state.saleBlock.epiServer.configuration,
    selectedAddress: state.saleBlock.selectedAddress,
    productsInfo: state.saleBlock.productsInfo,
    isOtherAddress: state.saleBlock.isOtherAddress,
    isSkipToNewCustomer: state.saleBlock.isSkipToNewCustomer,

    //other states
    _setupDeliveries: state.setupDeliveries.form,
    _technicianArrivalTimeError: state.technicianArrivalTime.form.errorId,
    _address: state.addressForm.form,
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setSupplyType,
  setSetupDeliveries,
  setError,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryAddressPage);
